<template>
  <div class="view login">
    <!-- <div class="alya-logo"></div> -->
    <img class="elem-logo" src="~@/assets/Logo_ELEM_1_white_short.png">
    <div class="login-content">
      <div class="login-texts">
        <div class="intro-text title">VHeart</div>
        <div class="intro-text sub-title">Cardiac Trials, Virtual Populations, High Performance Computing</div>
        <div class="intro-text mini-title">ELEM's Virtual Human Twin technology for the human heart</div>
      </div>
      <div class="login-forms login-panel" :style="{}">
        <form v-if="showEmailPasswordForm" @submit.prevent="validateCredentials">
          <input type="text" name="elem-username" placeholder="Email" v-model="username" />
          <input type="password" name="elem-password" placeholder="Password" v-model="password" />
          <input type="button" class="btn-login" value="Login" @click="validateCredentials"/>
          <div v-if="errorMessage" class="error-message">{{errorMessage}}</div>
        </form>
        <form v-else>
          <div class="mfa-text title">{{ mfaTitle }}</div>
          <div class="mfa-text summary">{{ mfaText }}</div>
          <div v-if="otpEnabled" class="code-form">
            <otp-input @input="code=$event"></otp-input>
            <input type="button" class="btn-login" value="Verify" @click="doLogin"/>
          </div>
          <div v-else class="qr-form">
            <div class="instructions-container">
              <div class="qr-code-container"><qrcode class="qr-code" :value="otpQrUri" :size="200"></qrcode></div>
              <div class="steps-container">
                <li class="text">1. Install Google Authenticator, Microsoft Authenticator or Authy on your mobile phone.</li>
                <li class="text">2. In the app, add an account or choose "Other account".</li>
                <li class="text">3. Scan the QR image.</li>
                <li class="text">If the app displays a six-digit code, you are done.</li>
              </div>
          </div>
            <input type="button" class="btn-login" value="Done" @click="enabledOTP"/>
          </div>
          <div v-if="errorMessage" class="error-message">{{errorMessage}}</div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/api'
import qrcode from 'qrcode.vue'
import OtpInput from '@/components/inputs/OtpInput'

export default {
  name: 'LoginView',
  components: { qrcode, OtpInput },
  data () {
    return {
      username: '',
      password: '',
      code: ['','','','','',''],
      otpQrUri: '',
      otpEnabled: false,
      errorMessage: '',
      showSidePanel: false,
      showEmailPasswordForm: true
    }
  },
  methods: {
    validateCredentials() {
      if(this.username && this.password) {
        this.errorMessage = ''
        Api.validateCredentials({username: this.username, password:this.password}).then((response) => {
          this.otpEnabled = response
          this.showEmailPasswordForm = false
          if (!this.otpEnabled) {
            Api.generateQR({username: this.username, password:this.password}).then((response) => {
              this.otpQrUri = response
            }) 
          }
        }).catch(error => {
          this.errorMessage = (error.response && error.response.data && error.response.data.detail) || error
        })
      } else {
        this.errorMessage = this.$t('email_password_required')
      }
    },
    doLogin () {
      let codeString = this.code.join("")
      if(this.username && this.password) {
        this.errorMessage = ''
        Api.login({username: this.username, password:this.password, client_secret:codeString}).then((response) => {
          this.$router.push({path: '/'})
        }).catch(error => {
          this.errorMessage = (error.response && error.response.data && error.response.data.detail) || error
        })
        this.$store.state.user = Api.getUser();
      }
    },
    enabledOTP() {
      if(this.username && this.password) {
        this.errorMessage = '';
        Api.userEnabledOTP({username: this.username, password:this.password}).then((response) => {
          this.otpEnabled = true
        }).catch(error => {
          this.errorMessage = (error.response && error.response.data && error.response.data.detail) || error
        })
      }
    },
    onClickOutside () {
      this.showSidePanel = false
    }    
  },
  computed: {
    mfaTitle() {
      if (this.otpEnabled) return 'Verification'
      else return 'Two-Factor Authentication'
    },
    mfaText() {
      if (this.otpEnabled) return 'Please enter the 6-digit code displayed in your Authenticator app'
      else return 'Since it is your first time logging in, we kindly ask you to set up 2FA to increase security'
    }
  }
}
</script>

<style lang="stylus">
.login
  background-color: #181721
  background-image: url("~@/assets/elem-login-bg.png")
  background-position: center center
  background-repeat: no-repeat
  background-size: cover
  height: 100%

  // .alya-logo
  //   background-image: url("~@/assets/alyared-logo-white.svg")
  //   background-position: left center
  //   background-repeat: no-repeat
  //   height: 30px
  //   margin-left: 60px
  //   margin-top: 60px
  //   width: 150px
  
  .elem-logo
    position: absolute
    left: 1vw
    top: 1vw
    width: 5vw

  .login-content
    height: 100%
    display: flex
    flex-direction: column
    justify-content: center
    margin-left: 5vw
    // margin: auto
    // margin-top: 80px
    width: 32%
    +m-breakpoint(sm md)
      width 100%
      margin-left: 60px
      margin-top: 60px
    
    .login-texts
      margin-bottom: 10px
      // height: 30%
    
    .login-forms
      height: 50%

  .intro-text
    color: #ffffff
    margin-bottom: 30px
    // width: 400px

    &.title
      m-font-size-r(3.5, 3.5)
      text-align: center
    &.sub-title
      m-font-size-r(2, 2)
      text-align: center
    &.mini-title
      color: rgba(#ffffff, 0.7)
      text-align: center
      width: 100%
      bottom: 5vh
      m-font-size-r(1.2, 1.5)

  .btn-login
    align-items: center
    border: 1px solid #FD204F
    background-color: #FD204F
    color: #ffffff
    cursor: pointer
    display: flex
    height: 50px
    justify-content: center
    m-font-size(16, 18)
    text-transform: uppercase
    width: 160px
    // background none 

  .login-panel
    // backdrop-filter: blur(50px)
    // background: rgba(#181d28, 0.9) 0 0 no-repeat padding-box
    
    background-color: rgba(white, 0.1) // $radical-red
    
    padding: 1.5vw
    display: flex
    flex-direction: column
    // height: 100%
    justify-content: center
    opacity: 1
    // padding: 50px
    // position: absolute
    // right: -40%
    // top: 0
    // transition: right 0.3s linear
    // width: 40%
    +m-breakpoint(sm md)
      width: 100%
      right: -100%
      background #181d28
    &.show
      right: 0

    .form-enter-active,
    .form-leave-active {
      transition: opacity 0.5s ease;
    }

    .form-enter,
    .form-leave-to {
      opacity: 0;
    }

    .mfa-text
        color: #ffffff
        text-align: center
        &.title
          m-font-size-r(1.5, 1.5)
          margin-bottom: 25px
        &.summary
          m-font-size-r(1.1, 1.5)
          margin-bottom: 20px

    .qr-form
      align-items: center
      .instructions-container
        display: flex
        flex-direction: row
        .qr-code-container
          width: 310px
          margin: 0 auto
          .qr-code
            box-shadow: 4px 4px 4px 4px rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)
            text-align: center
            background-color: white
            margin-bottom: 20px
        .steps-container
          margin: 0 auto
          display: flex
          flex-direction: column
          justify-content: center
          padding: 0 50px
          .text
            color: white
            margin-bottom: 30px
            m-font-size-r(1.1, 1.2)

    .close-icon
      cursor: pointer
      m-icon("cross", 25)
      position absolute
      top 50px
      left 50px
      display: none
      +m-breakpoint(sm md)
        display block

    input[type=text], input[type=password]
      background: transparent linear-gradient(180deg, #FFFFFF66 0, #FFFFFF 100%) 0 0 no-repeat padding-box
      border: none
      color: #000
      height: 60px
      m-font-size-r(1.1, 1.2)
      margin-bottom: 10px
      padding: 10px
      width: 100%

    .btn-login
      width: 100%
      outline none

  .error-message
    m-font-size(16, 18)
    color $titan-white
    margin-top 5px
</style>
